<!--联级题-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <p class="question-number">
            {{
              `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
            }}
          </p>
          <div class="question-select">
            <p>联级题</p>
          </div>
          <div style="display: flex; align-items: center; margin-left: 10px">
            <div class="select-box" @click="openLogicShow">
              <p
                style="
                  font-size: 14px;
                  margin-right: 5px;
                  color: #409eff;
                  cursor: pointer;
                "
              >
                联级选项设置
              </p>
            </div>
          </div>
        </div>

        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <div
        class="textarea-box"
        style="
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          margin-top: 10px;
        "
      >
        <textarea
          v-model="caseProblem"
          placeholder="请输入标题"
          maxlength="500"
          auto-height
          @input="handleInput"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            style="width: 18px; height: 18px; cursor: pointer"
            @click="triggerUpload"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>

      <div class="question-images">
        <div
          v-for="(item, idx) in images"
          :key="idx"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(idx)"
          />
        </div>
      </div>

      <div class="cascader-select">
        <div
          class="select"
          v-for="(title, idx) in titles"
          :key="idx"
          v-if="title"
        >
          {{ title }}
        </div>
      </div>

      <div class="add-view">
        <el-checkbox
          label="必选题"
          v-model="isMust"
          :true-label="1"
          :false-label="0"
          class="custom-checkbox"
          @change="handleCheckboxChange"
        ></el-checkbox>
      </div>
    </div>

    <div v-if="type === 1" class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>

    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />

    <div class="coverShow" v-show="logicShow">
      <div class="container-gj">
        <div class="container-gd">
          <div class="popup-header">
            <div
              v-if="breadcrumb.length > 1"
              class="back-btn"
              @click="backLevel"
            ></div>
            <div class="popup-title">联级选项设置</div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              alt=""
              class="popup-close"
              @click="logicShow = false"
            />
          </div>

          <div class="popup-body">
            <div class="breadcrumb">
              <span
                v-for="(item, index) in breadcrumb"
                :key="index"
                @click="index < breadcrumb.length - 1 && goToLevel(index)"
              >
                {{ item }}
                <span v-if="index !== breadcrumb.length - 1">/</span>
              </span>
            </div>

            <div class="title-input">
              <input
                type="text"
                v-model="titles[breadcrumb.length - 1]"
                placeholder="请输入当前层级标题"
                @change="handleUpdateQuestion"
              />
            </div>

            <div class="options-list">
              <div
                class="option-item"
                v-for="(opt, idx) in currentLevelOptions"
                :key="idx"
              >
                <div class="west">
                  <img
                    class="del-btn"
                    @click="deleteOption(idx)"
                    src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                  />
                  <input
                    type="text"
                    v-model="opt.label"
                    placeholder="请输入选项名"
                    @change="handleUpdateQuestion"
                  />
                </div>
                <div class="east" @click="enterChildLevel(opt)">
                  <div v-if="breadcrumb.length < 3" class="edit-btn">
                    {{ opt.children ? opt.children.length : 0 }}
                  </div>
                  <div class="icon"></div>
                </div>
              </div>
            </div>

            <div class="add-btns">
              <div class="batch" @click="showpopup = true">批量添加</div>
              <div class="add" @click="addOption">
                添加{{
                  ["一级", "二级", "三级"][breadcrumb.length - 1] || ""
                }}选项
              </div>
            </div>
          </div>

          <div class="popup-footer">
            <div class="confirm-btn" @click="logicShow = false">保存</div>
          </div>
        </div>
      </div>
    </div>

    <PopupInput
      :showDialog="showpopup"
      :title="'批量添加'"
      :aContent="''"
      :type="1"
      @close="showpopup = false"
      @confirm="bitchConfirm"
    ></PopupInput>
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: Object,
    index: Number,
    uuid: String,
    type: {
      type: Number,
      default: 1,
    },
    updateType: Number,
  },
  data() {
    return {
      dataObj: {},
      isMust: false,
      uploadIndex: 0,
      caseProblem: "",
      images: [],
      logicShow: false,
      showpopup: false,
      breadcrumb: ["一级选项"],
      options: [
        {
          label: "一级选项1",
          children: [],
        },
      ],
      currentLevelOptions: [],
      levelStack: [],
      titles: ["一级标题名称", "二级标题名称"],
      selectedIndices: [0, 0, 0],
      selectedLabels: ["", "", ""],
    };
  },
  mounted() {
    this.currentLevelOptions = this.options;
    const newVal = this.params;
    const copyVal = JSON.parse(JSON.stringify(newVal));
    this.dataObj = copyVal;
    this.caseProblem = copyVal.caseProblem || "";
    try {
      this.images = JSON.parse(copyVal.caseProblemImg || "[]");
    } catch (e) {
      this.images = [];
    }
    this.isMust = newVal.isMust === 1;

    try {
      const chooseListObj = JSON.parse(copyVal.chooseList || "{}");
      if (!chooseListObj.options || !chooseListObj.options.length) {
        this.options = [
          {
            label: "一级选项",
            children: [
              {
                label: "二级选项1",
                children: [],
              },
            ],
          },
        ];
        this.selectedIndices = [0, 0, 0];
        this.selectedLabels = ["", "", ""];
      } else {
        this.options = chooseListObj.options;
        this.selectedIndices = chooseListObj.selectedIndices || [0, 0, 0];
        this.selectedLabels = chooseListObj.selectedLabels || ["", "", ""];
      }
    } catch (e) {
      this.options = [
        {
          label: "一级选项",
          children: [
            {
              label: "二级选项1",
              children: [],
            },
          ],
        },
      ];
      this.selectedIndices = [0, 0, 0];
      this.selectedLabels = ["", "", ""];
    }

    if (copyVal.elseConfig) {
      if (Array.isArray(copyVal.elseConfig)) this.titles = copyVal.elseConfig;
      else if (typeof copyVal.elseConfig === "string")
        this.titles = copyVal.elseConfig.split(",").map((t) => t.trim());
    } else this.titles = ["一级标题名称", "二级标题名称"];

    this.breadcrumb = ["一级选项"];
    this.levelStack = [];
    this.currentLevelOptions = this.getCurrentLevelOptions();
    console.log("jguhrgehuiregurgerguirgiuerger", this.breadcrumb);
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("fil", file);
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.$message.success("上传成功！");
          this.images.push(res.data.urls);
          this.handleUpdateQuestion();
        })
        .catch((err) => {
          this.$message.error("上传失败！");
          console.error(err);
        });
    },

    handleInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    handleDeleteQuestionImage(idx) {
      this.images.splice(idx, 1);
      this.handleUpdateQuestion();
    },
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },

    handleUpdateQuestion() {
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem || "请输入题目说明";
      this.dataObj.chooseList = JSON.stringify({
        options: this.options,
        selectedLabels: this.selectedLabels,
        selectedIndices: this.selectedIndices,
      });
      this.dataObj.elseConfig = (
        this.titles || ["一级标题名称", "二级标题名称"]
      ).join(",");
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },

    saveClick() {
      if (!this.caseProblem.trim()) {
        this.$message.warning("请输入题目说明");
        return;
      }
      this.handleUpdateQuestion();
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },

    addOption() {
      const level = this.breadcrumb.length;
      let prefix = ["一级选项", "二级选项", "三级选项"][level - 1] || "选项";
      const list = this.currentLevelOptions;
      const newIndex = list.length + 1;
      list.push({
        label: `${prefix}${newIndex}`,
        children: level < 3 ? [] : undefined,
      });
    },

    deleteOption(index) {
      if (
        (this.breadcrumb.length === 1 || this.breadcrumb.length === 2) &&
        this.currentLevelOptions.length <= 1
      ) {
        this.$message.warning(
          `${["一级", "二级"][this.breadcrumb.length - 1]}选项至少保留一个`,
        );
        return;
      }
      this.currentLevelOptions.splice(index, 1);
      const levelIndex = this.breadcrumb.length - 1;
      if (this.currentLevelOptions.length === 0)
        this.titles.splice(levelIndex, 1);
      else if (!this.titles[levelIndex])
        this.titles[levelIndex] = [
          "一级标题名称",
          "二级标题名称",
          "三级标题名称",
        ][levelIndex];
      this.handleUpdateQuestion();
    },

    // 关键：获取当前 breadcrumb 层级的选项
    getCurrentLevelOptions() {
      let temp = this.options;
      for (let i = 0; i < this.breadcrumb.length - 1; i++) {
        const idx = this.selectedIndices[i] || 0;
        if (!temp[idx]) return [];
        temp = temp[idx].children || [];
      }
      return temp;
    },

    openLogicShow() {
      this.logicShow = true;
      this.currentLevelOptions = this.getCurrentLevelOptions();
    },

    // enterChildLevel(opt) {
    // 	if (!opt.children) this.$set(opt, "children", []);
    // 	this.levelStack.push(this.currentLevelOptions);
    // 	this.currentLevelOptions = opt.children;
    // 	this.breadcrumb.push(["二级选项", "三级选项"][this.breadcrumb.length - 1] || "子级");
    // },
    enterChildLevel(opt) {
      if (this.breadcrumb.length > 2) {
        this.$message.warning("最多只能添加三级选项");
        return;
      }
      if (!opt.children) this.$set(opt, "children", []);
      this.levelStack.push(this.currentLevelOptions);
      this.currentLevelOptions = opt.children;

      if (this.currentLevelOptions.length === 0) {
        this.currentLevelOptions.push({
          label:
            ["一级选项", "二级选项", "三级选项"][this.breadcrumb.length] + "1",
          children: this.breadcrumb.length < 2 ? [] : undefined,
        });
      }

      this.breadcrumb.push(
        ["二级选项", "三级选项"][this.breadcrumb.length - 1] || "子级",
      );
      this.handleUpdateQuestion();
    },

    bitchConfirm(content) {
      const items = content
        .split(/\n|,/)
        .map((i) => i.trim())
        .filter((i) => i);
      items.forEach((name) => {
        this.currentLevelOptions.push({
          label: name,
          children: [],
        });
      });
      this.showpopup = false;
      this.handleUpdateQuestion();
    },

    addOption() {
      const level = this.breadcrumb.length;
      const prefix = ["一级选项", "二级选项", "三级选项"][level - 1] || "选项";
      const list = this.currentLevelOptions;
      const newIndex = list.length + 1;
      list.push({
        label: `${prefix}${newIndex}`,
        children: level < 3 ? [] : undefined,
      });
      this.handleUpdateQuestion();
    },

    deleteOption(index) {
      if (
        (this.breadcrumb.length === 1 || this.breadcrumb.length === 2) &&
        this.currentLevelOptions.length <= 1
      ) {
        this.$message.warning(
          `${["一级", "二级"][this.breadcrumb.length - 1]}选项至少保留一个`,
        );
        return;
      }
      this.currentLevelOptions.splice(index, 1);
      const levelIndex = this.breadcrumb.length - 1;
      if (this.currentLevelOptions.length === 0)
        this.titles.splice(levelIndex, 1);
      else if (!this.titles[levelIndex])
        this.titles[levelIndex] = [
          "一级标题名称",
          "二级标题名称",
          "三级标题名称",
        ][levelIndex];
      this.handleUpdateQuestion();
    },

    backLevel() {
      this.currentLevelOptions = this.levelStack.pop() || this.options;
      this.breadcrumb.pop();
    },

    goToLevel(index) {
      console.log("fefefewfwefwefew");

      if (index === this.breadcrumb.length - 1) return;
      this.breadcrumb = this.breadcrumb.slice(0, index + 1);
      this.currentLevelOptions = this.getCurrentLevelOptions();
      this.levelStack = this.levelStack.slice(0, index);
    },

    bitchConfirm(content) {
      const items = content
        .split(/\n|,/)
        .map((i) => i.trim())
        .filter((i) => i);
      items.forEach((name) => {
        this.currentLevelOptions.push({
          label: name,
          children: [],
        });
      });
      this.showpopup = false;
    },
  },

  watch: {
    // params: {
    //   handler(newVal) {
    //     if (!newVal) return;
    //     console.log("newVal11111111111111111", newVal);
    //     const copyVal = JSON.parse(JSON.stringify(newVal));
    //     this.dataObj = copyVal;
    //     this.caseProblem = copyVal.caseProblem || "";
    //     try {
    //       this.images = JSON.parse(copyVal.caseProblemImg || "[]");
    //     } catch (e) {
    //       this.images = [];
    //     }
    //     this.isMust = newVal.isMust === 1;
    //     try {
    //       const chooseListObj = JSON.parse(copyVal.chooseList || "{}");
    //       if (!chooseListObj.options || !chooseListObj.options.length) {
    //         this.options = [
    //           {
    //             label: "一级选项",
    //             children: [
    //               {
    //                 label: "二级选项1",
    //                 children: [],
    //               },
    //             ],
    //           },
    //         ];
    //         this.selectedIndices = [0, 0, 0];
    //         this.selectedLabels = ["", "", ""];
    //       } else {
    //         this.options = chooseListObj.options;
    //         this.selectedIndices = chooseListObj.selectedIndices || [0, 0, 0];
    //         this.selectedLabels = chooseListObj.selectedLabels || ["", "", ""];
    //       }
    //     } catch (e) {
    //       this.options = [
    //         {
    //           label: "一级选项",
    //           children: [
    //             {
    //               label: "二级选项1",
    //               children: [],
    //             },
    //           ],
    //         },
    //       ];
    //       this.selectedIndices = [0, 0, 0];
    //       this.selectedLabels = ["", "", ""];
    //     }
    //     if (copyVal.elseConfig) {
    //       if (Array.isArray(copyVal.elseConfig))
    //         this.titles = copyVal.elseConfig;
    //       else if (typeof copyVal.elseConfig === "string")
    //         this.titles = copyVal.elseConfig.split(",").map((t) => t.trim());
    //     } else this.titles = ["一级标题名称", "二级标题名称"];
    //     this.breadcrumb = ["一级选项"];
    //     this.levelStack = [];
    //     this.currentLevelOptions = this.getCurrentLevelOptions();
    //     console.log("jguhrgehuiregurgerguirgiuerger", this.breadcrumb);
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
};
</script>

<style scoped>
.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1010;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 1010;
  transform: translate(-50%, -50%);
  overflow: hidden;
}

.popup-header {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
  justify-content: center;
}

.popup-header .back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translate(0, -50%) rotate(-45deg);
  width: 13px;
  height: 13px;
  border-top: 1px solid #888888;
  border-left: 1px solid #888888;
}

.popup-header .popup-close {
  width: 13px;
  height: 13px;
  position: absolute;
  right: 20px;
}

.popup-body {
  padding: 0 14px;
}

.popup-body .breadcrumb {
  font-size: 12px;
  color: #a7a7a7;
  padding: 18px 0 5.5px;
  text-align: left;
  cursor: pointer;
}

.popup-body .title-input {
  font-size: 17px;
  color: #3a60ff;
  font-weight: bold;
  margin-top: 5.5px;
  margin-bottom: 19px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
}

.popup-body .title-input input {
  width: 100%;
}

.popup-body .options-list {
}

.popup-body .options-list .option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
}

.popup-body .options-list .option-item .west {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-body .options-list .option-item .west .del-btn {
  width: 17px;
  height: 17px;
  flex: none;
}

.popup-body .options-list .option-item .east {
  display: flex;
  align-items: center;
  gap: 5px;
}

.popup-body .options-list .option-item .east .edit-btn {
  color: #3a60ff;
  font-size: 13px;
}

.popup-body .options-list .option-item .east .icon {
  transform: rotate(-45deg);
  width: 7px;
  height: 7px;
  border-bottom: 1px solid #888888;
  border-right: 1px solid #888888;
  margin-right: 1px;
  margin-top: 0.5px;
}

.popup-body .add-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  margin-bottom: 10px;
  font-size: 13px;
  position: relative;
}

.popup-body .add-btns .batch {
  color: #509dee;
  font-size: 14px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.popup-body .add-btns .add {
  width: 190px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #3a60ff;
  color: #3a60ff;
  border-radius: 25px;
  font-size: 15px;
}

.popup-footer .confirm-btn {
  padding: 13px 0;
  border-top: 1px solid #e4e4e4;
  color: #4a73f8;
  font-size: 15px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

.cascader-select {
  margin: 10px 0;
}

.cascader-select .select {
  width: 100%;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 3px;
  font-size: 14px;
  color: #2b2f36;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  position: relative;
}

.cascader-select .select + .select {
  margin-top: 5px;
}

.cascader-select .select::after {
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%) rotate(45deg);
  margin-top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditCASCADER.vue